import {Icon, IconBulb} from '@flixbus/honeycomb-icons-react';
import {Box, Heading, Link, Text} from '@flixbus/honeycomb-react';
import {POWER_BI_REPORT_REGIONAL_COST_DATABASE_URL} from '@/constants/PowerBiReportUrls';
import styles from './RegionalCostsVehicleCostHelpBox.module.scss';

const guidelinesLink =
  'https://einfachbusfahren.sharepoint.com/sites/BusinessDevelopment/SitePages/Production-Cost-Governance.aspx';

const RegionalCostsVehicleCostHelpBox: React.FC = () => {
  return (
    <>
      <Heading size={3} sectionHeader>
        Need help with production cost data?
      </Heading>
      <Box extraClasses="regional-costs-help-box">
        <div className={styles.content}>
          <Icon
            InlineIcon={IconBulb}
            size={8}
            extraClasses="brand-primary-color"
          />
          <Text>
            Check out how other countries report their costs in the{' '}
            <Link
              target="_blank"
              href={POWER_BI_REPORT_REGIONAL_COST_DATABASE_URL}
            >
              Power BI cost database
            </Link>
            , and review the{' '}
            <Link target="_blank" href={guidelinesLink}>
              production cost guidelines
            </Link>{' '}
            for tips on what to include.
          </Text>
        </div>
      </Box>
    </>
  );
};

export default RegionalCostsVehicleCostHelpBox;
